import React, { lazy } from "react";
import { Route, Switch } from "react-router-dom";
import { App } from "modules/App/App";
import { NoMatch } from "templates/NoMatch/NoMatch";
import { MainPage } from "modules/MainPage/MainPage";
import { PrivateRoute } from "HOC/WithPermissions/WithPermissions";
import { ROUTES_MAP } from "routes/constants";

const ROUTES = [
    {
        ...ROUTES_MAP.tracker,
        component: lazy(() => import("../modules/Tracker"))
    },
    {
        ...ROUTES_MAP.users,
        component: lazy(() => import("../modules/Users"))
    },
    {
        ...ROUTES_MAP.scheduler,
        component: lazy(() => import("../modules/Scheduler"))
    },
    {
        ...ROUTES_MAP.configManager,
        component: lazy(() => import("../modules/ConfigManager"))
    },
    {
        ...ROUTES_MAP.branches,
        component: lazy(() => import("../modules/Branches"))
    },
    {
        ...ROUTES_MAP.brands,
        component: lazy(() => import("../modules/Brands"))
    },
    {
        ...ROUTES_MAP.brandTrackedDomains,
        component: lazy(() => import("../modules/Brands"))
    },
    {
        ...ROUTES_MAP.userAgents,
        component: lazy(() => import("../modules/UserAgents"))
    },
    {
        ...ROUTES_MAP.initialScrapeTaskBatchStarts,
        component: lazy(() => import("../modules/InitialScrapeTaskBatchStarts"))
    },
    {
        ...ROUTES_MAP.objectStructures,
        component: lazy(() => import("../modules/ObjectStructures"))
    },
    {
        ...ROUTES_MAP.roles,
        component: lazy(() => import("../modules/Roles"))
    },
    {
        ...ROUTES_MAP.configCIPublishRequests,
        component: lazy(() => import("../modules/ConfigCI"))
    },
    {
        ...ROUTES_MAP.configCITestTasks,
        component: lazy(() => import("../modules/ConfigCI"))
    },
    {
        ...ROUTES_MAP.metric,
        component: lazy(() => import("../modules/Metric"))
    },
    {
        ...ROUTES_MAP.credentials,
        component: lazy(() => import("../modules/CredentialsManager"))
    },
    {
        ...ROUTES_MAP.credentialsTypes,
        component: lazy(() => import("../modules/CredentialsManager"))
    },
    {
        ...ROUTES_MAP.configManagerLite,
        component: lazy(() => import("../modules/ConfigManagerLite"))
    },
    {
        ...ROUTES_MAP.proxyManager,
        component: lazy(() => import("../modules/ProxyManager"))
    },
    {
        ...ROUTES_MAP.quotaManager,
        component: lazy(() => import("../modules/QuotaManager"))
    },
    {
        ...ROUTES_MAP.primaryKey,
        component: lazy(() => import("../modules/PrimaryKey"))
    },
    {
        ...ROUTES_MAP.siteGroups,
        component: lazy(() => import("../modules/ConfigManager"))
    },
    {
        ...ROUTES_MAP.sqsQueues,
        component: lazy(() => import("../modules/Queues"))
    },
    {
        ...ROUTES_MAP.noPermissions,
        component: lazy(() => import("../templates/NoPermissionsPage"))
    }
];

export const Routes = (
    <App>
        <Switch>
            <Route
                exact
                path="/"
                component={MainPage}
            />

            {
                ROUTES.map(({ path, exact, component, permission }) => (
                    <PrivateRoute
                        key={path}
                        path={path}
                        exact={exact}
                        permission={permission}
                        component={component}
                    />
                ))
            }

            <Route component={NoMatch} />
        </Switch>
    </App>
);
